import { Component, inject, signal, AfterViewInit } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

import { FlowTheme } from './core/services/flow-theme';
import { Seo } from './core/services/seo';
import { CookieBanner } from './core/layout/cookie-banner/cookie-banner';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CookieBanner],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements AfterViewInit {
  private router = inject(Router);
  // Injected for its side effect: paints the Recycle flow green.
  private readonly flowTheme = inject(FlowTheme);
  private readonly seo = inject(Seo);

  protected readonly title = signal('snap-send-portal');
  private headerOffset = 80;

  ngAfterViewInit(): void {
    // Listen to NavigationEnd to catch fragment navigation
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        const tree = this.router.parseUrl(this.router.url);
        const fragment = tree.fragment;
        if (fragment) {
          this.scrollToFragment(fragment);
        }
      });
  }

  private scrollToFragment(id: string) {
    const el = document.getElementById(id);
    if (!el) {
      // element not found — maybe still not in DOM yet. Try a small retry.
      setTimeout(() => {
        const elRetry = document.getElementById(id);
        if (elRetry) this.doScrolling(elRetry);
      }, 50);
      return;
    }
    this.doScrolling(el);
  }

  private doScrolling(el: HTMLElement) {
    const elementPosition = el.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - this.headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
}
